var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayerTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1305 175C43.602 173.81 42.8104 171.838 42.8379 169.087C42.9521 157.668 42.8852 146.245 42.8852 134.826V133.092C41.3964 133.092 40.0376 133.112 38.6749 133.092C35.8943 133.046 34.0274 131.241 34.0274 128.502C34.0116 115.862 33.9565 103.218 34.051 90.5786C34.118 81.6289 41.7036 73.8219 50.6914 73.6341C60.266 73.4345 69.8524 73.4306 79.427 73.6341C88.6078 73.8258 96.0634 81.5819 96.1619 90.9582C96.2919 103.402 96.2131 115.851 96.1895 128.295C96.1855 131.304 94.3187 133.073 91.2742 133.096C90.0099 133.108 88.7417 133.096 87.312 133.096V134.955C87.312 146.425 87.2687 157.895 87.3435 169.365C87.3632 172.077 86.4573 173.99 83.8736 175.004H72.9639C71.3372 174.288 69.9548 173.325 69.6437 171.423C69.5295 170.707 69.5098 169.967 69.5098 169.239C69.5019 160.364 69.5098 151.489 69.5019 142.617C69.5019 140.406 68.8284 139.753 66.6031 139.722C65.6697 139.71 64.7362 139.714 63.8067 139.722C61.2585 139.737 60.6283 140.375 60.6244 142.962C60.6244 151.739 60.5496 160.517 60.6677 169.29C60.7032 171.998 59.8446 173.904 57.3357 175.004H46.1305V175Z",
    fill: "url(#paint0_linear_26_302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1499 64.7083C54.1653 64.7787 45.1933 55.923 45.1264 44.9423C45.0594 34.0008 53.9605 25.0511 64.9609 25.0002C76.0006 24.9493 85.0081 33.766 85.0632 44.6801C85.1184 55.7312 76.2606 64.6339 65.1499 64.7044V64.7083Z",
    fill: "url(#paint1_linear_26_302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.996 60.3916C164.996 64.5162 164.799 64.7157 160.703 64.7157C158.017 64.7157 158.048 64.7275 157.079 67.2007C154.704 73.2623 150.4 77.3322 144.133 79.2497C143.07 79.5745 142.731 80.0206 142.81 81.0615C142.893 82.1298 142.857 83.2099 142.818 84.2821C142.759 85.8905 141.947 86.7201 140.352 86.771C139.029 86.814 137.698 86.814 136.374 86.771C134.76 86.7162 134.003 85.914 133.96 84.2665C133.921 82.8029 134.409 81.0302 133.74 79.9736C133.133 79.0149 131.25 78.8975 129.982 78.2987C124.649 75.7708 121.034 71.7088 119.297 66.0932C118.958 64.9936 118.497 64.6023 117.375 64.6962C116.252 64.7901 115.114 64.7431 113.988 64.6883C112.593 64.6179 111.802 63.8313 111.739 62.4617C111.672 61.049 111.664 59.6285 111.735 58.2158C111.81 56.6739 112.593 55.95 114.193 55.8795C115.417 55.8248 116.654 55.9382 117.875 55.8208C118.312 55.7778 118.962 55.363 119.08 54.9834C121.302 47.9199 125.965 43.3336 133.058 41.1108C133.444 40.9895 133.877 40.3556 133.917 39.9251C134.035 38.665 133.929 37.3893 133.972 36.1214C134.023 34.6774 134.819 33.883 136.288 33.8282C137.662 33.7773 139.041 33.7812 140.415 33.8282C141.932 33.8791 142.759 34.7009 142.822 36.2192C142.869 37.3893 142.873 38.5633 142.822 39.7333C142.782 40.5747 142.999 40.9739 143.921 41.2556C150.86 43.3805 155.417 47.9434 157.56 54.8308C157.82 55.6682 158.194 55.9109 158.997 55.8756C160.077 55.8287 161.16 55.8443 162.239 55.8717C164.248 55.9187 164.976 56.6583 165 58.6423C165.008 59.2293 165 59.8124 165 60.3994L164.996 60.3916ZM149.435 60.2546C149.411 54.099 144.472 49.2544 138.253 49.2935C132.176 49.3287 127.233 54.2908 127.253 60.3289C127.276 66.418 132.31 71.3409 138.474 71.3018C144.574 71.2627 149.454 66.3437 149.431 60.2546H149.435Z",
    fill: "url(#paint2_linear_26_302)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_302",
    x1: 65.1159,
    y1: 73.4829,
    x2: 65.1159,
    y2: 175.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_302",
    x1: 65.0947,
    y1: 25,
    x2: 65.0947,
    y2: 64.7087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_302",
    x1: 138.344,
    y1: 33.7915,
    x2: 138.344,
    y2: 86.8033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 150,
    fill: "white",
    transform: "translate(34 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerTracking);
export default __webpack_public_path__ + "static/media/Player_Tracking.ebbf3a5c88ef51c803b6c60b7076ddc6.svg";
export { ForwardRef as ReactComponent };